import React from "react"
import Constants from "expo-constants";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { nameNonErrorRejection } from "./nonErrorRejection";

// The browser's expected refusals of media playback: autoplay policy, a play()
// interrupted by pause() or a new load, a source it cannot play. PlaySound
// already treats them as noise, but expo-audio's web player calls media.play()
// without handling its promise, so they reach Bugsnag as unhandled rejections.
const EXPECTED_PLAYBACK_ERRORS = new Set(["NotAllowedError", "AbortError", "NotSupportedError"])

export const isExpectedPlaybackRefusal = (event) => {
    const error = event.errors[0]
    if (!event.unhandled || !EXPECTED_PLAYBACK_ERRORS.has(error?.errorClass)) return false
    // Safari's NotAllowedError carries the same message as a denied mic or
    // camera — only the play() frame says it is playback.
    const fromPlay = (error.stacktrace ?? []).some((frame) => frame.method === "play")
    return fromPlay || /play|source/i.test(error.errorMessage ?? "")
}

export const initBugsnag = () => {
    return (!__DEV__) ?
        Bugsnag.start({
            apiKey: Constants.expoConfig.extra.bugsnag.apiKey,
            plugins: [new BugsnagPluginReact()],
            releaseStage: Constants.expoConfig.extra.releaseStage,
            enabledReleaseStages: ['production', 'staging', 'integration'],
            appVersion: Constants.expoConfig.version,
            onError: (event) => !isExpectedPlaybackRefusal(event) && nameNonErrorRejection(event),
        }) : null
}
export const initErrorBoundary = () => {
    return Bugsnag.getPlugin('react').createErrorBoundary(React)
}

// `severity` et `groupingHash` : pour un refus attendu qu'on veut compter sans le tenir pour un
// défaut, dans un groupe stable d'un déploiement à l'autre (Bugsnag groupe sinon par le code).
export const notifyBugsnag = (error, metadata, { severity, groupingHash } = {}) => {
    if ((!__DEV__))
        Bugsnag.notify(error, (event) => {
            if (metadata) event.addMetadata("context", metadata)
            if (severity) event.severity = severity
            if (groupingHash) event.groupingHash = groupingHash
        })
}

export const leaveBugsnagBreadcrumb = (name, metadata) => {
    if ((!__DEV__))
        Bugsnag.leaveBreadcrumb(name, metadata)
}

export const setBugsnagUser = (user) => {
    if ((!__DEV__))
        Bugsnag.setUser(user?.id, user?.email, user?.display_name)
}